import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { FormBuilder } from "@/widgets/formbuilder/ui/formbuilder"
import { fetchUsersForm, selectFormFields, selectFormFirstLoad, selectFormId, selectFormLoading } from "../model"
import { useEffect } from "react"

export const UsersProfilebuilderPage = () => {
    const usersFormFirstLoad = useAppSelector(selectFormFirstLoad)
    const dispatch = useAppDispatch()
    const usersFormLoading = useAppSelector(selectFormLoading)
    const usersFormId = useAppSelector(selectFormId)
    const usersForm = useAppSelector(selectFormFields)

    const onUpdate = () => {
        dispatch(fetchUsersForm())
    }

    useEffect(() => {
        if (usersFormFirstLoad) {
            dispatch(fetchUsersForm())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Пользователи" />
            <div className='flexbox'>
                <PageSubtitle title="Конструктор профиля" />
                <FormBuilder 
                    formId={usersFormId}
                    update={onUpdate}
                    fields={usersForm} 
                    isLoading={usersFormLoading} 
                />
            </div>
        </div>
    )
}